require('../styles/mailer.scss');



// WEBPACK FOOTER //
// ./app/javascript/packs/mailer.js